import { useState, useEffect } from 'react';
import { DefaultSettingsService, DefaultSettings } from '../services/defaultSettingsService';

/**
 * Hook to fetch default settings (prioritize, AIs) from Firestore
 * Returns fallback defaults immediately, then updates when Firestore loads
 */
export function useDefaultSettings() {
  const [settings, setSettings] = useState<DefaultSettings>(
    DefaultSettingsService.getFallbackDefaults()
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const fetchSettings = async () => {
      try {
        const defaults = await DefaultSettingsService.getDefaults();
        if (mounted) {
          setSettings(defaults);
          setLoading(false);
        }
      } catch (error) {
        console.error('Error fetching default settings:', error);
        if (mounted) {
          setLoading(false);
        }
      }
    };

    fetchSettings();

    return () => {
      mounted = false;
    };
  }, []);

  return {
    defaultPrioritize: settings.defaultPrioritize,
    defaultAIs: settings.defaultAIs,
    loading,
  };
}



